import BreadcrumbsComponent from "@atoms/Breadcrumbs/Breadcrumbs";
import color from "@definitions/mui/color";
import HeadAndFilterMobile from "@fragments/HeadAndFilter/Mobile";
import useResponsive from "@helpers/useResponsive";
import Footer from "@layouts/Footer";
import { HeaderLP } from "@layouts/Main/lib/Header/HeaderLP";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import LayoutMobile from "@pwa/layout";
import ContentMenuScroll from "../components/ContentMenuScroll";
import HtmlRenderer from "../components/HtmlRenderer";
interface IPropsPrivacy {
  dataPolicy: {
    content: string;
    toc: string[];
  };
  dataNavbar: TProductIconData[];
}

const PrivacyDesktop: React.FC<IPropsPrivacy> = ({
  dataNavbar,
  dataPolicy,
}) => {
  const isMobile = useResponsive("md");

  const contentTerms = (
    <Box>
      <Box
        bgcolor={color.grey.mid}
        width="100%"
        py={1}
        px={isMobile ? 2 : 0}
        position={isMobile ? "static" : "sticky"}
        top="70px"
        mt="70px"
        zIndex={2}
        display={isMobile ? "none" : "block"}
      >
        <Container maxWidth="lg" disableGutters>
          {!isMobile && (
            <BreadcrumbsComponent
              homeUrl={{ label: "Beranda", productPath: "/" }}
              breadcrumbs={[{ label: "Kebijakan Privasi" }]}
            />
          )}
        </Container>
      </Box>
      <ContentMenuScroll title="Kebijakan Privasi" tableOfContents={dataPolicy.toc}>
        <HtmlRenderer content={dataPolicy.content} isMobile={isMobile} isServerRendering />
      </ContentMenuScroll>
    </Box>
  );

  if (isMobile) {
    return (
      <LayoutMobile layoutType="noMenuTopBottom">
        <HeadAndFilterMobile title="Kebijakan Privasi" goBack={true} noShadow={true} />
        <Box pt={6}>{contentTerms}</Box>
      </LayoutMobile>
    );
  }

  return (
    <>
      <HeaderLP />
      {contentTerms}
      <Footer bgColor="grey-mid" dataNavbar={dataNavbar} />
    </>
  );
};

export default PrivacyDesktop;
